export const userPrivateRoutesConstants = {
  root: {
    path: "/r/app/user",
    href: () => "/r/app/user"
  },
  user_management: {
    path: "/r/app/user/list",
    href: (projectId: string) => `/r/app/user/list?project=${projectId}`
  },
  user_profile: {
    path: "/r/app/user/profile",
    href: () => `/r/app/user/profile`
  }
} as const;
